$(function() {
  'use strict';
  
  var slick_options_defaults = {
    'prevArrow': '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    'nextArrow': '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',
    fade: true,
    speed: 800,
    infinite: true,
    dots: false,
    autoplay: false,
    autoplaySpeed: 4000,
    pauseOnFocus: false,
    pauseOnHover: false,
    arrows: false,
    slidesToShow: 1,
  };

  $('.slick-container').each(function() {
    var $slick_container = $(this);
    var slick_opts = Object.create(slick_options_defaults);

    if($slick_container.hasClass("dots")) {
      slick_opts.dots = true;
    }

    if($slick_container.hasClass("arrows")) {
      slick_opts.arrows = true;
    }

    // if($slick_container.hasClass("some-class")) {
    //   slick_opts.slidesToScroll = 1;
    //   slick_opts.autoplay = false;
    //   slick_opts.mobileFirst = true;
    //   slick_opts.responsive = [
    //       {
    //         breakpoint: 768,
    //         settings: {
    //           fade: false,
    //           slidesToShow: 2
    //         }
    //       }
    //     ]; 
    // }
    
    if($slick_container.hasClass("autoplay")) {
      slick_opts.autoplay = true;
    }

    if($slick_container.hasClass("amenities")) {
      slick_opts.draggable = false;
      slick_opts.swipe = false;
      slick_opts.swipeToSlide = false;
      slick_opts.touchMove = false;
      slick_opts.accessibility = false;
      slick_opts.dots = false;
    }

    $slick_container.on('afterChange', function(event, slick, currentSlide){
      //play video on slide change
      var $slide_obj = $slick_container.find("[data-slick-index='" + currentSlide + "']");
      var $video = $slide_obj.find('video');
      if(typeof $video != 'undefined' && $video.length && Foundation.MediaQuery.atLeast('medium')) {
        $video.get(0).play();
      } 
    });

    $slick_container.on('beforeChange', function(event, slick, currentSlide){
      //pause video on slide change
      var $slide_obj = $slick_container.find("[data-slick-index='" + currentSlide + "']");
      var $video = $slide_obj.find('video');
      if(typeof $video != 'undefined' && $video.length && Foundation.MediaQuery.atLeast('medium')) {
        $video.get(0).pause();
      } 
    });

     $slick_container.on('init', function(event){
      //play video on carousel load if available
      var $slide_obj = $slick_container.find("[data-slick-index='0']");
      var $video = $slide_obj.find('video');
      if(typeof $video != 'undefined' && $video.length && Foundation.MediaQuery.atLeast('medium')) {
        $video.get(0).play();
      } 

      setTimeout(function() {
        // Recalulate scrollify sizes after content loaded
          $.scrollify.update();
        }, 300);
      });

    // Resize and reset the slicks on window change or orientation change
    $(window).on('resize orientationchange', debounce(function() {
      $slick_container.slick('resize');
    },300));

    //Slick Away!
    $slick_container.slick(slick_opts);

  });

});